import React, { forwardRef } from "react";
import { useTheme } from "../../../hooks";
import GenericModal from "../../modal/genericModal/GenericModal";
import GenericPopover from "../generic/GenericPopover";
import PopoverBody from "./PopoverBody";
import PopoverFooter from "./PopoverFooter";
import PopoverHeader from "./PopoverHeader";
const PopoverSub = forwardRef(({ children, styles = {}, ...rest }, ref) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.popover, ...styles };
    return (React.createElement(GenericPopover, { element: ref, ...rest },
        React.createElement(GenericModal, { styles: StylesOverride }, children)));
});
PopoverSub.Header = PopoverHeader;
PopoverSub.Body = PopoverBody;
PopoverSub.Footer = PopoverFooter;
const Popover = PopoverSub;
export default Popover;
//# sourceMappingURL=Popover.js.map